import { doc, setDoc } from "@firebase/firestore";
import {
    Button,
    Dialog,
    DialogContent,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TextField,
} from "@mui/material";
import React, { useState } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { db } from "../../../api/firebase";
import { DepartmentsAutoComplete } from "../../../components/AutoComplete/Departments";
import { RawItemsAutoComplete } from "../../../components/AutoComplete/RawItems";
//Create Bill Button
const collectionName = "product";

export const IssueMaterialDialog = ({ open, onClose, items }) => {
//   const depa = useSelector((state) => state.products.products);

  const [quantity, setQuantity] = useState("");
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState();
  const [issueMaterials, setIssueMaterial] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState();

  const updateMaterialsOnHand = async (close) => {
    console.log(selectedDepartment,issueMaterials);
    let promise = [];
    try {
    issueMaterials.forEach(async (item) => {
        let pro = setDoc(doc(db, "departments/"+selectedDepartment.id+"/inventory", item.id+""), {
            onHand: item.quantity
        }).then(()=>{})
        promise.push(pro);

    })
      toast.success("Successfully update  item !", {
        position: toast.POSITION.BOTTOM_CENTER,
      });
      // nbfProductInfo();
    } catch (error) {
      // console.log(error);
      toast.error("Failed to  update  item!", {
        position: toast.POSITION.BOTTOM_CENTER,
      });
    }

    if (close) {
      onClose();
    }
  };

  return (
    <Dialog open={open} size="lg" style={{ zIndex: 900 }}>
      <form onSubmit={(e) => e.preventDefault()}>
        <DialogContent>
          <Stack
            sx={{
              width: "100%",
              minWidth: { xs: "300px", sm: "360px", md: "550px" },
              gap: "1.5rem",
            }}
          >
            <Stack alignItems="center" spacing={1} direction="row">
              {/* <ProductsAutoComplete
                value={selectedProduct}
                onChange={(e, newValue) => {
                  setSelectedProduct(newValue);
                  setRecipe(newValue.recipe || []);
                }}
              /> */}
              <DepartmentsAutoComplete
                value={selectedDepartment}
                onChange={(e, newValue) => {
                  setSelectedDepartment(newValue);
                //   setRecipe(newValue.recipe || []);
                }}/>
            </Stack>
            <Stack alignItems="center" spacing={1} direction="row">
              <label style={{ minWidth: "30%" }}>
                <RawItemsAutoComplete
                  value={selectedItem}
                  onChange={(e, newValue) => {
                    console.log(newValue);
                    setSelectedItem(newValue);
                  }}
                />
                {/* <Autocomplete
                    disablePortal
                    label="Select Product"
                    id="combo-box-demo"
                    options={[]}
                    sx={{ minWidth: "100%" }}
                    value={selectedItem}
                    onChange={handleItemChange}
                    renderInput={(params) => (
                      <TextField {...params} label="Select Item" />
                    )}
                  /> */}
              </label>
              <label style={{ minWidth: "20%" }}>
                <TextField
                  sx={{ minWidth: "100%" }}
                  type="number"
                  label="Enter Quantity"
                  value={quantity}
                  onChange={(e) => setQuantity(e.target.value)}
                />
              </label>
              <label style={{ minWidth: "10%" }}>
                <Button
                  variant="outlined"
                  sx={{
                    minWidth: "100%",
                    height: "55px",
                    bgcolor: "blue",
                    color: "white",
                  }}
                  onClick={() => {
                    if (!selectedItem || !quantity) return;
                    let index = issueMaterials.findIndex(
                      (rec) => rec.name === selectedItem.name
                    );
                    if (index !== -1) {
                        issueMaterials[index].quantity = quantity;

                      setIssueMaterial([...issueMaterials]);
                      setSelectedItem(null);
                      setQuantity(0);
                      return;
                    }
                    setIssueMaterial([
                      ...issueMaterials,
                      {
                        id: selectedItem.id,
                        name: selectedItem.name,
                        quantity: quantity,
                        unit: selectedItem.unit,
                        lastPrice: selectedItem.lastPrice,
                      },
                    ]);
                    setSelectedItem(null);
                    setQuantity(0);
                  }}
                >
                  Add
                </Button>
              </label>
            </Stack>

            <Table
              sx={{
                maxHeight: "10rem",
                overflowY: "auto",
                display: "block",
              }}
            >
              <TableHead>
                <TableRow>
                  <TableCell width={"25%"} align="center">
                    Item
                  </TableCell>
                  <TableCell width={"25%"} align="center">
                    Quantity
                  </TableCell>
                  <TableCell width={"25%"} align="center">
                    Unit
                  </TableCell>
                  <TableCell width={"25%"} align="center">
                   On Hand (after)
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {issueMaterials.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell align="center">{row.name}</TableCell>
                    <TableCell align="center">{row.quantity}</TableCell>
                    <TableCell align="center">{row.unit}</TableCell>
                    <TableCell align="center">{row.onHand}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Stack>
        </DialogContent>

        <Stack
          sx={{ p: "1.25rem" }}
          justifyContent="center"
          direction="row"
          spacing={1}
        >
          <Button id="cancel-button" onClick={onClose} variant="contained">
            Cancel
          </Button>
          <Button
            id="save-button"
            color="secondary"
            onClick={() => updateMaterialsOnHand(false)}
            variant="contained"
          >
            Update
          </Button>
          <Button
            id="save-button"
            color="secondary"
            onClick={() => updateMaterialsOnHand(true)}
            variant="contained"
          >
            Update & Close
          </Button>
        </Stack>
      </form>
    </Dialog>
  );
};
